﻿import Transfer from "./transfer";

export default class ProductApi {
    static apiBase = "/api/shop/";

    static getCategoriesByArea(areaObj) {
        var fullUrl = ProductApi.apiBase + "categories/" + areaObj.siteId + "/";

        if (areaObj.areaId) {
            fullUrl += areaObj.areaId + "/" + String(areaObj.keyAccountOnly);
        } else {
            fullUrl + String(areaObj.keyAccountOnly);
        }

        return Transfer({
            url: fullUrl
        });
    }

    static getCategories(siteId, voucherActive) {
        return Transfer({
            url: ProductApi.apiBase + "categories/" + siteId + "/" + voucherActive
        });
    }

    static attendeesGet(dateLocationObj) {
        return Transfer({
            method: "POST",
            data: dateLocationObj,
            url: ProductApi.apiBase + "attendance"
        });
    }

    static locationsGetBySiteId(siteId) {
        return Transfer({
            url: ProductApi.apiBase + "locations/" + siteId
        });
    }

    static getKeyAccountContract() {
        return Transfer({
            url: ProductApi.apiBase + "keyaccountcontract"
        });
    }

    static getProduct(siteId, identifier, urlExt = "") {
        identifier = identifier.replace(".aspx", "");

        return Transfer({
            url: ProductApi.apiBase + "product/" + siteId + "/" + identifier + urlExt
        });
    }

    static getProductById(siteId, productId) {
        return Transfer({
            url: ProductApi.apiBase + "product/" + siteId + "/" + productId
        });
    }

    static getProducts({ searchObj, urlExt = "" }) {
        return Transfer({
            method: "POST",
            data: searchObj,
            url: ProductApi.apiBase + "products" + urlExt
        });
    }

    static getProductsCount(searchObj) {
        return Transfer({
            method: "POST",
            data: searchObj,
            url: ProductApi.apiBase + "products/count"
        });
    }

    static getProductsById({ data, urlExt }) {
        return Transfer({
            method: "POST",
            data: data,
            url: ProductApi.apiBase + "productList?" + urlExt
        });
    }

    static getActiveWeekdays(areaObj) {
        return Transfer({
            url: ProductApi.apiBase + "weekdays/" + areaObj.siteId + "/" + areaObj.areaId + "/" + areaObj.keyAccountOnly
        });
    }
}
